export default __webpack_public_path__ + "static/media/dashboardLogo.660db674.svg";